// extracted by mini-css-extract-plugin
module.exports = {"controls":"a10a3f92e9--controls--KOXNS","controls--hidden":"a10a3f92e9--controls--hidden--HHuWy","single":"a10a3f92e9--single--JxPPy"};